export default "__VITE_ASSET__BOPBWRY$__"